<template>
  <div v-loading="isLoading">
    <el-table
      :data="addresses"
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="6">
              <p><strong>Name: </strong>{{ props.row.name || 'None' }}</p>
              <p><strong>Code: </strong>{{ props.row.code || 'None' }}</p>
              <p><strong>RTP: </strong>{{ props.row.rtp_account || 'None' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Address: </strong>{{ `${props.row.line_one || ''} ${props.row.line_two || ''}` }}</p>
              <p><strong>Suburb: </strong>{{ props.row.suburb || 'None' }}</p>
              <p><strong>State: </strong>{{ props.row.state || 'None' }}</p>
              <p><strong>Postcode: </strong>{{ props.row.postcode || 'None' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Contact: </strong>{{ props.row.contact || 'None' }}</p>
              <p><strong>Phone: </strong>{{ props.row.phone || 'None' }}</p>
              <p><strong>Email: </strong>{{ props.row.email || 'None' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Special Instructions: </strong>{{ props.row.spi || 'None' }}</p>
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <el-table-column
        label="Name"
        prop="name"
        min-width="320px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Code"
        prop="code"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Suburb"
        prop="suburb"
        width="240px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Postcode"
        prop="postcode"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="State"
        prop="state"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
        width="270px"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editAddress(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteAddress(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <AddressEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :is-show.sync="isShowEditForm"
      :address="address"
      :account-id="accountId"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import AddressEditForm from '@/components/Application/Manage/Account/AddressEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'

export default {
  components: {
    AddressEditForm
  },
  props: {
    filters: {
      type: Array,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      address: null,
      addresses: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true,
      isShowEditForm: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_address')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_address')
    }
  },
  mounted () {
    this.actions = [
      [
        {
          name: 'Import',
          icon: ['fal', 'upload'],
          event: () => {
            this.$emit('update:isShowImport', true)
          }
        },
        {
          name: 'Export',
          icon: ['fal', 'download'],
          event: () => {
            this.$emit('update:isShow', true)
          }
        }
      ],
      [
        {
          hidden: this.$user.cannot(CREATE, 'account_address'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.address = new this.$sdk.account_address()
            this.isShowEditForm = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.loadTable()
        }
      ]
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.account_address.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.include = ['carrier_service', 'carrier_service.carrier']
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'created_at:asc'
        builder.filters = this.filters
      })
        .then(res => {
          this.addresses = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    editAddress (index, row) {
      this.address = row
      this.isShowEditForm = true
    },
    deleteAddress (index, row) {
      this.$confirm('Are you sure to delete this address?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
